var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('h1',[_vm._v("Consulta de propietarios VUR")]),_c('vur-owner-manager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }